import { gql } from 'apollo-angular';

const FRAGMENT_USER = gql`
  fragment User on User {
    accessGlobalSettings
    activeClientId
    activeServiceProviderId
    activeUserId
    createdAt
    email
    firstName
    id
    isActive
    lastName
    phone
    roleId
    title
    updatedAt
    userCompanies {
      companyId
    }
  }
`;

const GET_USERS = gql`
  query getUsers {
    users {
      ...User
    }
  }
  ${FRAGMENT_USER}
`;

const GET_USER = gql`
  query getUser($id: UUID!) {
    users(where: { id: { eq: $id } }) {
      ...User
    }
  }
  ${FRAGMENT_USER}
`;

const ADD_USER = gql`
  mutation addUser($user: UserMutationInput!, $logInfo: EntityLogInfoInput!) {
    addUser(user: $user, logInfo: $logInfo) {
      ...User
    }
  }
  ${FRAGMENT_USER}
`;

const UPDATE_USER = gql`
  mutation updateUser(
    $user: UserMutationInput!
    $logInfo: EntityLogInfoInput!
  ) {
    updateUser(user: $user, logInfo: $logInfo) {
      ...User
    }
  }
  ${FRAGMENT_USER}
`;

const DELETE_USER = gql`
  mutation deleteUser($id: UUID!, $logInfo: EntityLogInfoInput!) {
    deleteUser(id: $id, logInfo: $logInfo)
  }
`;

export const GET_USERS_PAGED = gql`
  query usersPaged($first: Int, $after: String, $where: UserPagedFilterInput) {
    usersPaged(
      first: $first
      after: $after
      where: $where
      order: { user: { createdAt: DESC } }
    ) {
      edges {
        cursor
        node {
          user {
            ...User
          }
          count
          total
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
  ${FRAGMENT_USER}
`;

export { GET_USERS, GET_USER, ADD_USER, UPDATE_USER, DELETE_USER };
